import { useRouteError } from 'react-router';
import { TriangleAlert } from 'lucide-react';
import { EmptyState } from '@/components/EmptyState';
import { Button } from '@/components/ui/button';

/** Route error boundary: plain Hebrew, details only in the console. */
export function ErrorPage() {
  const error = useRouteError();
  console.error(error);
  return (
    <div className="flex min-h-[60dvh] items-center justify-center p-4">
      <EmptyState
        icon={TriangleAlert}
        title="משהו השתבש בעמוד הזה"
        action={<Button onClick={() => window.location.reload()}>טעינה מחדש</Button>}
      >
        הנתונים שלכם שמורים. נסו לטעון את העמוד מחדש; אם זה חוזר, פנו למנהל המערכת.
      </EmptyState>
    </div>
  );
}
